import { reactive, isReactive, toRaw } from 'vue';

function Vueset(target, key, value) {
    if (Array.isArray(target) && Number.isInteger(key)) {
        // When target is an array and key is an integer, replace the element at the index
        target.splice(key, 1, value);
    } else if (isReactive(target)) {
        // When target is a reactive object, set the property directly
        // Vue 3's reactivity system will track this change
        target[key] = value;
    } else {
        // If target is not reactive, it's a plain object or array.
        // Convert it to a reactive object and assign the value.
        // Note: This branch is more for illustrating purposes; typically, you'd ensure
        // objects are reactive beforehand in Vue 3.
        const reactiveTarget = reactive(toRaw(target));
        reactiveTarget[key] = value;
    }
}

export default Vueset;
